import React from "react"

export function TextIcon(){

    return(
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512" fill="currentColor">
      
        <path d="M48 80v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V72C0 49.9 17.9 32 40 32H408c22.1 0 40 17.9 40 40v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H248l0 352h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h48l0-352H48z"/></svg>
    )

}

export function LinkIcon(){

    return(
<   svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512" fill="currentColor">

    <path d="M580.3 267.2c56.2-56.2 56.2-147.3 0-203.5C526.8 10.2 440.9 7.3 383.9 57.2l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6L433.1 346.6c-37.4 37.4-98.2 37.4-135.6 0c-35.7-35.7-37.6-92.9-4.4-130.9l4.7-5.4c8.7-10 7.7-25.1-2.3-33.9s-25.1-7.7-33.9 2.3l-4.7 5.4c-49.8 57-46.9 142.9 6.6 196.4c56.2 56.2 147.3 56.2 203.5 0L580.3 267.2zM59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6L207 165.4c37.4-37.4 98.1-37.4 135.6 0c35.7 35.7 37.6 92.9 4.4 130.9l-5.4 6.1c-8.7 10-7.7 25.1 2.3 33.9s25.1 7.7 33.9-2.3l5.4-6.1c49.9-57 47-142.9-6.5-196.5c-56.2-56.2-147.3-56.2-203.5 0L59.7 244.8z"/></svg>
   )

}

export function HeadingIcon(){


    return(
        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512" fill="currentColor">
        <path d="M0 56C0 42.7 10.7 32 24 32H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H104V224H344V80H312c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H392V248 432h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H312c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V272H104V432h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V248 80H24C10.7 80 0 69.3 0 56z"/></svg>
    )

}

export function SectionIcon(){

    return(  
        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512" fill="currentColor">

    <path d="M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120v32V360v32c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H592v8c0 13.3 10.7 24 24 24s24-10.7 24-24V360 152 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H320 48v-8zm0 56H320 592V336H48V176z"/></svg>

      )




}

export function ContainerIcon(){

    return(
<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512" fill="currentColor"> <path d="M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"/></svg>
    )

}

export function RowIcon(){

    return(
<svg xmlns="http://www.w3.org/2000/svg" height="1em" width={"1em"} viewBox="0 0 14 6"fill="currentColor">
<path d="M12.8594 2.20312H1.14062C0.730469 2.20312 0.4375 1.91016 0.4375 1.5C0.4375 1.11914 0.730469 0.796875 1.14062 0.796875H12.8594C13.2402 0.796875 13.5625 1.11914 13.5625 1.5C13.5625 1.91016 13.2402 2.20312 12.8594 2.20312ZM12.8594 5.95312H1.14062C0.730469 5.95312 0.4375 5.66016 0.4375 5.25C0.4375 4.86914 0.730469 4.54688 1.14062 4.54688H12.8594C13.2402 4.54688 13.5625 4.86914 13.5625 5.25C13.5625 5.66016 13.2402 5.95312 12.8594 5.95312Z" />
</svg>
    )

}

export function ColumnIcon(){

    return(
<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="currentColor"> <path d="M224 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H192c17.7 0 32-14.3 32-32zm0 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H192c17.7 0 32-14.3 32-32zM0 320c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM224 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H192c17.7 0 32-14.3 32-32zM288 64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zM512 192c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32zM288 320c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32zM512 448c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32z"/></svg>
    )

}


export function SpacerIcon(){

    return(
<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 512 512" height="1em" fill="currentColor"> <path d="M0 56C0 69.3 10.7 80 24 80H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24C10.7 32 0 42.7 0 56zM368 208v96H144V208H368zM144 160c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H144zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"/></svg>
    )

}


export function ImageIcon(){

    return(
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12" height="1em"  fill="currentColor">
<path d="M14.0938 0.75H1.90625C1.11523 0.75 0.5 1.39453 0.5 2.15625V10.5938C0.5 11.3848 1.11523 12 1.90625 12H14.0938C14.8555 12 15.5 11.3848 15.5 10.5938V2.15625C15.5 1.39453 14.8555 0.75 14.0938 0.75ZM13.918 10.5938H2.08203C1.96484 10.5938 1.90625 10.5352 1.90625 10.418V2.33203C1.90625 2.24414 1.96484 2.15625 2.08203 2.15625H13.918C14.0059 2.15625 14.0938 2.24414 14.0938 2.33203V10.418C14.0938 10.5352 14.0059 10.5938 13.918 10.5938ZM4.25 3.32812C3.57617 3.32812 3.07812 3.85547 3.07812 4.5C3.07812 5.17383 3.57617 5.67188 4.25 5.67188C4.89453 5.67188 5.42188 5.17383 5.42188 4.5C5.42188 3.85547 4.89453 3.32812 4.25 3.32812ZM3.3125 9.1875H12.6875V6.84375L10.1094 4.29492C9.96289 4.14844 9.75781 4.14844 9.61133 4.29492L6.125 7.78125L4.95312 6.63867C4.80664 6.49219 4.60156 6.49219 4.45508 6.63867L3.3125 7.78125V9.1875Z" />
</svg>
    )

}


export function ButtonIcon(){

    return(
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="1em" fill="currentColor">
   <path d="M448 112c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H448zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"/></svg>
    )

}

export function TabsIcon(){
return <svg xmlns="http://www.w3.org/2000/svg" height="1em" fill="currentColor" viewBox="0 0 640 512"><path d="M448 80V432H576c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H448zm-48 0H240V432H400V80zM192 432V80H64c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H192zM0 96C0 60.7 28.7 32 64 32H576c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"/></svg>

}